// extracted by mini-css-extract-plugin
export var active = "_kr-e";
export var blink = "_kr-f";
export var dropDownSelector = "_kr-5";
export var dropDownWrapper = "_kr-4";
export var fakeCursor = "_kr-d";
export var fontSizeButton = "_kr-7";
export var formQuillEditor = "_kr-0";
export var pressed = "_kr-g";
export var qlBlank = "_kr-1";
export var textFormattingToolbar = "_kr-2";
export var textFormattingToolbarClosed = "_kr-3";
export var textFormattingToolbarInline = "_kr-6";
export var textToolbarOption = "_kr-8";
export var toolbarCell = "_kr-a";
export var toolbarCellCollapsed = "_kr-b";
export var toolbarOptionHitArea = "_kr-c";
export var toolbarOverflow = "_kr-9";